module.exports = __webpack_public_path__ + "img/20210321.6a263f25.gif";